import { useSyncExternalStore } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

function getMediaQuery(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null
  return window.matchMedia(QUERY)
}

/** Leitura pontual (fora de componentes): o usuário pediu menos movimento? */
export function prefersReducedMotion(): boolean {
  return getMediaQuery()?.matches ?? false
}

function subscribe(onChange: () => void): () => void {
  const query = getMediaQuery()
  if (!query) return () => undefined
  query.addEventListener('change', onChange)
  return () => query.removeEventListener('change', onChange)
}

/** Hook reativo: re-renderiza quando a preferência do sistema muda. */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, prefersReducedMotion, () => false)
}
